import { sqliteTable, text, real, index } from "drizzle-orm/sqlite-core";
import { accounts } from "./accounts";

// ============================================================================
// bank_statement_lines — imported/manual bank statement movements
// ============================================================================
export const bankStatementLines = sqliteTable("accounting_bank_statement_lines", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  accountId: text("account_id").notNull().references(() => accounts.id),
  statementDate: text("statement_date").notNull(),
  description: text("description").notNull(),
  referenceNo: text("reference_no"),
  partyName: text("party_name"),
  partyType: text("party_type", {
    enum: ["customer", "supplier", "employee", "other"],
  }),
  partyId: text("party_id"),
  direction: text("direction", {
    enum: ["inflow", "outflow"],
  }).notNull(),
  amount: real("amount").notNull(),
  currencyCode: text("currency_code").notNull().default("THB"),
  status: text("status", {
    enum: ["unmatched", "partially_matched", "matched", "suspense", "cancelled"],
  }).notNull().default("unmatched"),
  importBatchId: text("import_batch_id"),
  externalId: text("external_id"),
  rawData: text("raw_data"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at"),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyAccountDateIdx: index("bank_stmt_company_account_date_idx")
    .on(table.companyId, table.accountId, table.statementDate),
  companyBranchDateIdx: index("bank_stmt_company_branch_date_idx")
    .on(table.companyId, table.branchId, table.statementDate),
  companyDateIdx: index("bank_stmt_company_date_idx")
    .on(table.companyId, table.statementDate),
  companyStatusIdx: index("bank_stmt_company_status_idx")
    .on(table.companyId, table.status, table.statementDate),
  referenceIdx: index("bank_stmt_reference_idx")
    .on(table.companyId, table.referenceNo),
}));

export type BankStatementLine = typeof bankStatementLines.$inferSelect;
export type NewBankStatementLine = typeof bankStatementLines.$inferInsert;
